import React from 'react'
import { TemplateSub } from 'src/components/layouts/TemplateSub'
import { QrCode } from "src/components/shared/QrCode";
import { useFindBaseUrl } from "@njoy/controller";
import { ViewTransaction } from '@njoy/controller';
import { useParams } from 'react-router-dom';
import { Popover } from "antd";
import copyIcon from "src/assets/svg/copyIconBold.svg"
import CaptureButton from 'src/modules/shared/CaptureButton';
import moment from 'moment'
import PageLoader from 'src/modules/shared/PageLoader';
export const RedemptionDetailsPage: React.FC = () => {
    const { transactionId } = useParams<{ transactionId: string }>();
    const { baseUrl } = useFindBaseUrl();
    const redemptionRef = React.useRef<HTMLDivElement>(null);
    const getPrimaryCode = (
        value: string | Array<string | null> | null | undefined
    ) => {
        if (Array.isArray(value)) {
            return (
                value.find(
                    (code): code is string =>
                        typeof code === "string" && code.trim().length > 0
                ) || ""
            );
        }
        return typeof value === "string" ? value : "";
    };
    return (
        <TemplateSub page={"Redemption Details"}>
            <ViewTransaction transactionId={transactionId!}>
                {({ transaction, loading }) => {
                    if (loading) {
                        return <PageLoader />;
                    }

                    const code = getPrimaryCode(
                        transaction?.offer?.offerType === "Voucher"
                            ? transaction?.partnerVoucher
                            : transaction?.njoyCode
                    );
                    const displayCode = typeof code === "string" && code
                        ? code.length > 10
                            ? `${code.toUpperCase().slice(0, 10)}...`
                            : code.toUpperCase()
                        : "";

                    const handleCopyCode = async () => {
                        if (code) {
                            try {
                                await navigator.clipboard.writeText(code.toUpperCase());
                            } catch (err) {
                                console.error("Failed to copy code:", err);
                            }
                        }
                    };

                    return (
                        <div className=" w-full h-full px-[1rem] flex flex-col justify-center ">
                            <div ref={redemptionRef} className=" gradient-bg w-full py-5 flex-col flex items-center justify-center">
                                <div className="flex w-[275px] h-[275px] p-6 bg-white items-center justify-center rounded-md ">
                                    {loading ? (
                                        "..."
                                    ) : (
                                        <QrCode
                                            value={`${baseUrl}/validation-portal/validate/${transaction?.njoyCode!}`}
                                            size={250}
                                        />
                                    )}
                                </div>
                                <div className=" flex flex-col items-center w-full px-1 justify-center">
                                    <hr className="bg-[#77777] mt-7 border 1px solid w-full border-[#7777]" />
                                    <div className="flex gap-2 w-full items-start justify-start mt-3">
                                        <img src={transaction?.offer?.createdBy?.admin?.merchantProfile?.logoUrl!} className='rounded-full object-cover w-[40px] h-[40px]' alt="merchant logo" />
                                        <div className='flex flex-col gap-1'>
                                            <p className='text-[16px] text-white'> {transaction?.offer?.title}</p>
                                            <p className='text-[12px] text-white opacity-50'> {transaction?.offer?.createdBy?.admin?.merchantProfile?.companyName}</p>
                                        </div>
                                    </div>
                                    <div className='flex w-full flex-col mt-4'>
                                        <div className="flex flex-col justify-between items-center mt-2">
                                            <div className="flex justify-between items-center w-full">
                                                <p className="text-[16px] text-[#E1E1E1] opacity-65 font-light">{transaction?.offer?.offerType === "Voucher" ? "Partner Code" : "Njoy Code"}</p>
                                                <div className="flex items-center gap-1">
                                                    <p className="text-[16px] text-white">{displayCode}</p>
                                                    <div className="mb-1 cursor-pointer" onClick={handleCopyCode}>
                                                        <Popover
                                                            placement="topLeft"
                                                            arrowPointAtCenter
                                                            content="Copied!"
                                                            trigger="click"
                                                        >
                                                            <img crossOrigin="anonymous" src={copyIcon} alt="copy" />
                                                        </Popover>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className="bg-[#77777] mt-2 border 1px solid w-full border-[#7777]" />
                                        </div>

                                         <div className="flex flex-col items-center mt-2">
                                            <div className='flex justify-between w-full'>
                                                <p className="text-[16px] text-[#E1E1E1] font-light opacity-65">Offer Type</p>
                                                <p className="text-[16px] text-white">{transaction?.offer?.offerType}</p>
                                            </div>
                                            <hr className="bg-[#77777] mt-2 border 1px solid w-full border-[#7777]" />
                                        </div>

                                        <div className="flex flex-col items-center mt-2">
                                            <div className="flex justify-between w-full">
                                                <p className="text-[16px] text-[#E1E1E1] font-light opacity-65">Date</p>
                                                <p className="text-[16px] text-white">{transaction?.offer?.createdAt &&
                                                    moment(transaction.createdAt).format("Do MMMM YYYY")}</p>
                                            </div>
                                            <hr className="bg-[#77777] mt-2 border 1px solid w-full border-[#7777]" />
                                        </div>
                                    
                                        <div className="flex justify-between items-center mt-2">
                                            <p className="text-[16px] text-[#E1E1E1] opacity-65 font-light">Time</p>
                                            <p className="text-[16px] text-white">{transaction?.offer?.createdAt &&
                                                moment(transaction.createdAt).format("h:mm A")}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='px-[1rem] my-9'>
                                <CaptureButton
                                    targetRef={redemptionRef as React.RefObject<HTMLElement>}
                                    fileName="redemption-receipt"
                                    variant="primary"
                                />
                            </div>
                        </div>
                    )
                }}
            </ViewTransaction>
        </TemplateSub >
    )
}
